/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `Footer`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  Labels: {
    Bottom: `بناء شيء عظيم ™`,
    Top: `© 2019 Boral. بورال. كل الحقوق محفوظة`,
  },
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  Labels: {
    Bottom: `Build something great ™`,
    Top: `© 2019 Boral. All rights reserved`,
  },
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  Labels: {
    Bottom: `建立偉大的東西™`,
    Top: `©2019 Boral. 版權所有`,
  },
});
